import { connect } from 'react-redux'
import React from 'react'
import { AppState } from '@chegg-wt/core/state'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import MetaDescription from '@chegg-wt/core/components/Head/MetaDescription'
import { PageStructureProps } from '@chegg-wt/core/components/SourceSearchPageStructure/types'
import SourceSearchPageStructure, {
  SourceSearchPageStructureTop,
} from '@chegg-wt/core/components/SourceSearchPageStructure'
import {
  sourceTypeSelected,
  sourceQueryEntered,
} from '@chegg-wt/core/state/createCitation/actions'
import { currentSourceSelector } from '@chegg-wt/core/state/createCitation/selectors'
import { NextPageWithLayout } from '@chegg-wt/core/types/layout'
import { getLvpLayout } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import { getUrlStyleNameV2 } from '@chegg-wt/core/api/oneGraph'
import { Config } from '@chegg-wt/core/config'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import seoContent from '../../copy/seo-content/mla__website.html'
import upgradeCopy from '../../copy/upgrade'

interface MlaWebsiteProps {
  initialUrlStyleName: string
}

const MlaWebsite: NextPageWithLayout<PageStructureProps & MlaWebsiteProps> = ({
  initialUrlStyleName,
  currentStyle = 'mla9',
  currentSourceType = 'website',
  selectSourceType,
  currentSourceTypeResource,
  setSearchQuery,
}) => {
  useOnUnloadTimeOnPage()
  return (
    <>
      <SEOTitle title="Free Citing a Website in MLA | Citation Machine" />
      <MetaDescription content="Cite websites effortlessly in MLA format with Citation Machine. Properly credit your sources and generate accurate citations for professional projects." />
      <SourceSearchPageStructure
        copy={{ seoContent, upgradeCopy }}
        styleId="mla9"
        initialUrlStyleName={initialUrlStyleName}
        initialSourceType="website"
        currentStyle={currentStyle}
        currentSourceType={currentSourceType}
        setSearchQuery={setSearchQuery}
        selectSourceType={selectSourceType}
        currentSourceTypeResource={currentSourceTypeResource}
      />
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  currentSourceTypeResource: currentSourceSelector(state),
})

const mapDispatchToProps = {
  selectSourceType: sourceTypeSelected,
  setSearchQuery: sourceQueryEntered,
}

export const getServerSideProps = async () => {
  const styleId = 'mla9'
  const currentSourceType = 'website'
  const [initialUrlStyleName] = await getUrlStyleNameV2(styleId)
  return {
    props: {
      initialUrlStyleName,
      isDefaultStyle: Config.currentStyle === styleId,
      currentSourceType,
    },
  }
}

MlaWebsite.getPageLayout = (page, ssrProps) =>
  getLvpLayout(page, () => <SourceSearchPageStructureTop {...ssrProps} />)

export default connect(mapStateToProps, mapDispatchToProps)(MlaWebsite)
